// ============================================================
// 主题配置（单一数据源）
// 5 套主题：candy 糖果风（默认，原样式零改动）+ 4 套扁平插画浅色系
// 通过 CSS 变量（--brand 等）+ data-theme 属性实现一键切换
// 财务语义色（涨红/跌绿）不随主题变，AI 员工品牌色不随主题变
// ============================================================

const STORAGE_KEY = 'ledou-theme';

// 每套主题的 CSS 变量值
// brand       主色（按钮/链接/强调/图表主序列）
// brandStrong 深主色（选中文字/logo/重点）
// brandBg     页面背景
// brandBorder 边框
// brandSoft   选中浅底
// brandHover  悬停浅底
// brandRgb    主色 RGB 分量（用于 rgba() 阴影/光晕）
// gradFrom    品牌渐变浅端（logo 渐变）
export const THEMES = {
  candy: {
    label: '糖果风',
    desc: '珊瑚橙 · 暖白（默认）',
    brand: '#D85A30',
    brandStrong: '#993C1D',
    brandBg: '#FFF8F4',
    brandBorder: '#F3E2D8',
    brandSoft: '#FAECE7',
    brandHover: '#FAF0EA',
    brandRgb: '216, 90, 48',
    gradFrom: '#E86A3C',
    chartPrimary: '#D85A30',
    // antd token 派生色
    antdBgLayout: '#FFF8F4',
    antdBorder: '#EBD9CE',
    antdBorderSecondary: '#F3E2D8',
    antdMenuSelectedBg: '#FAECE7',
    antdMenuSelectedColor: '#993C1D',
    antdMenuHoverBg: '#FAF0EA',
    antdMenuHoverColor: '#7A4A33',
    antdTableHeaderBg: '#FFF8F4',
    antdTableHeaderColor: '#5B5048',
    antdTableRowHover: '#FDF3EC',
  },
  mint: {
    label: '薄荷奶昔',
    desc: '薄荷绿 · 清新',
    brand: '#4FB48A',
    brandStrong: '#2E8C67',
    brandBg: '#F7FCFA',
    brandBorder: '#D8EFE4',
    brandSoft: '#E9F7F0',
    brandHover: '#EFF8F4',
    brandRgb: '79, 180, 138',
    gradFrom: '#6BC79E',
    chartPrimary: '#4FB48A',
    antdBgLayout: '#F7FCFA',
    antdBorder: '#D0E9DC',
    antdBorderSecondary: '#D8EFE4',
    antdMenuSelectedBg: '#E9F7F0',
    antdMenuSelectedColor: '#2E8C67',
    antdMenuHoverBg: '#EFF8F4',
    antdMenuHoverColor: '#2E8C67',
    antdTableHeaderBg: '#F7FCFA',
    antdTableHeaderColor: '#5B5048',
    antdTableRowHover: '#F0FAF5',
  },
  peach: {
    label: '蜜桃乌龙',
    desc: '蜜桃橙 · 温暖',
    brand: '#F09A6E',
    brandStrong: '#DE7B4E',
    brandBg: '#FDF7F3',
    brandBorder: '#F4DFD0',
    brandSoft: '#FCEBE0',
    brandHover: '#FDF1E9',
    brandRgb: '240, 154, 110',
    gradFrom: '#F5B08A',
    chartPrimary: '#F09A6E',
    antdBgLayout: '#FDF7F3',
    antdBorder: '#F0D8C7',
    antdBorderSecondary: '#F4DFD0',
    antdMenuSelectedBg: '#FCEBE0',
    antdMenuSelectedColor: '#DE7B4E',
    antdMenuHoverBg: '#FDF1E9',
    antdMenuHoverColor: '#C96A40',
    antdTableHeaderBg: '#FDF7F3',
    antdTableHeaderColor: '#5B5048',
    antdTableRowHover: '#FDF0E8',
  },
  blue: {
    label: '晴空蓝莓',
    desc: '天蓝 · 清爽',
    brand: '#5E9BE0',
    brandStrong: '#3E78B8',
    brandBg: '#F6FAFE',
    brandBorder: '#D9E7F5',
    brandSoft: '#E3EEF9',
    brandHover: '#EBF3FB',
    brandRgb: '94, 155, 224',
    gradFrom: '#7DB0E6',
    chartPrimary: '#5E9BE0',
    antdBgLayout: '#F6FAFE',
    antdBorder: '#C9DDEF',
    antdBorderSecondary: '#D9E7F5',
    antdMenuSelectedBg: '#E3EEF9',
    antdMenuSelectedColor: '#3E78B8',
    antdMenuHoverBg: '#EBF3FB',
    antdMenuHoverColor: '#3E78B8',
    antdTableHeaderBg: '#F6FAFE',
    antdTableHeaderColor: '#5B5048',
    antdTableRowHover: '#EDF4FC',
  },
  lemon: {
    label: '柠檬香草',
    desc: '柠檬黄 · 明快',
    brand: '#D9A820',
    brandStrong: '#B8860B',
    brandBg: '#FEFBF3',
    brandBorder: '#F0E4C0',
    brandSoft: '#FAEFD2',
    brandHover: '#FCF5DE',
    brandRgb: '217, 168, 32',
    gradFrom: '#EEC24A',
    chartPrimary: '#EEC24A',
    antdBgLayout: '#FEFBF3',
    antdBorder: '#E8D9AA',
    antdBorderSecondary: '#F0E4C0',
    antdMenuSelectedBg: '#FAEFD2',
    antdMenuSelectedColor: '#B8860B',
    antdMenuHoverBg: '#FCF5DE',
    antdMenuHoverColor: '#A07B10',
    antdTableHeaderBg: '#FEFBF3',
    antdTableHeaderColor: '#5B5048',
    antdTableRowHover: '#FCF6E2',
  },
};

const THEME_KEYS = Object.keys(THEMES);

// 读 localStorage，非法值回退 candy
export function loadThemeKey() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && THEMES[v]) return v;
  } catch (e) { /* ignore */ }
  return 'candy';
}

export function getTheme(key) {
  return THEMES[key] || THEMES.candy;
}

export function getThemeKeys() {
  return THEME_KEYS;
}

// 应用主题：写 data-theme + 同步 CSS 变量 + 记忆到 localStorage
export function applyTheme(key) {
  const t = getTheme(key);
  const root = document.documentElement;
  root.setAttribute('data-theme', key);
  // 直接把变量写到 :root，供内联 style 和 index.css 的 var() 引用
  root.style.setProperty('--brand', t.brand);
  root.style.setProperty('--brand-strong', t.brandStrong);
  root.style.setProperty('--brand-bg', t.brandBg);
  root.style.setProperty('--brand-border', t.brandBorder);
  root.style.setProperty('--brand-soft', t.brandSoft);
  root.style.setProperty('--brand-hover', t.brandHover);
  root.style.setProperty('--brand-rgb', t.brandRgb);
  root.style.setProperty('--grad-from', t.gradFrom);
  try {
    localStorage.setItem(STORAGE_KEY, key);
  } catch (e) { /* ignore */ }
  return t;
}

// 应用后让图表/组件重新读取（简单可靠：整页刷新，主题切换是低频操作）
export function switchTheme(key) {
  applyTheme(key);
  window.location.reload();
}
